import { z } from 'zod'

export const cashRegisterSchema = z.object({
  valorInicial: z
    .any()
    .default(0)
    .transform((value) => parseFloat(value.toString().replaceAll('.', '').replace('R$ ', '').replace(',', '.'))),
  idResponsavel: z.any().transform((value) => parseInt(value || '0')),
  nomeResponsavel: z.string()
})

export type openCashRegisterForm = z.infer<typeof cashRegisterSchema>
